module.exports = __webpack_public_path__ + "static/media/peter9.d15ff45a.jpg";